<template>
    <v-container class="container loginPage">
        <img class="imageHeader" src="@/assets/loogo-.png" :alt="$t('navbar.title')" />
        <v-row>
            <v-col cols="12" >    
                <h1 class="mb-4">المكتبة الشاملة الذهبية </h1>
                <p>جهد جبار و جمع مميز وعمل فريد ........ جودة ...... تميز ......احترافية ..... ضخامة ...... إبداع ..... عناية ......... إتقان ....... خلاصة عمل 12 سنة من التجميع والتدقيق والفهرسة والتحديث والفرز وقد كلف ذلك الكثير من الوقت والجهد والمال (تأكد أنها الأفضل)</p>
            </v-col>
            <v-col cols="12">
                <h2 class="mb-4">ميزات و مراحل عمل المكتبة الشاملة الذهبية  :</h2>
                <ul>
                    <li class="mb-3">
                        تم جمع  المكتبة الشاملة المكية + الشاملة الوقفية +الشاملة المدنية + الشاملة التاريخية + الشاملة الرسمية + الشاملة المستودع +  مكتبة مشكاة الإسلامية + موقع الكتيبات الإسلامية + مكتبة صيد الفوائد + موقع الوراق + مكتبة الألوكة + موقع الباحث العلمي + موقع روح الإسلام + كتب شبكة رفد الثقافية +كتب ملتقى أهل الحديث + ألف كتاب حصري ينشر لأول مرة + كتب تبرع بها أصحابها + الكثير الكثير من المواقع والموسوعات العلمية +الكثير من الكتب التي قمنا بتفريغها يدويا  = المكتبة الشاملة الذهبية 44 ألف كتاب بجودة عالية مع كامل بيانات الكتاب في البطاقة .
                    </li>
                    <li class="mb-3">
                        المكتبة الشاملة الذهبية خالية من التكرار 100٪ حيث استغرق حذف الكتب المكررة عام كامل بطرق فنية معقدة احترافية غير تقليدية .
                    </li>
                    <li class="mb-3">
                        في المكتبة الشاملة الذهبية تم تشجير وفهرسة جميع الكتب باحترافية وهي قابلة للبحث والاقتباس .
                    </li>
                    <li class="mb-3">
                       المكتبة الشاملة الذهبية لاتحوي على كتب شرعية فقط (وهي الأغلب)، بل تعدت ذلك لكثير من العلوم والفنون على سبيل المثال لا الحصر:كتب إدارة - كتب اقتصاد ومحاسبة - كتب علم نفس - كتب علم اجتماع -كتب فلسفة -كتب منطق - كتب علوم سياسية - كتب حقوق وقانون - كتب علوم عسكرية واستراتيجية - كتب دبلوماسية - كتب نباتات وحيوان - كتب تنمية بشرية - كتب مالية ومصارف - كتب علوم اللغة والنحو والصرف - كتب تسويق دولي - كتب سياسة شرعية وقضاء - كتب إدارة الوقت والذات - كتب القيادة والإدارة الاستراتيجية - كتب التربية والتعليم - كتب الرقائق - كتب جغرافيا وبلدان -كتب  أنساب - كتب تاريخ وغيرها الكثير من المجالات ......
                    </li>
                    <li class="mb-3">
                       المكتب الشاملة الذهبية تحوي 44 ألف كتاب نصي منها 1500 كتاب فارسي وهذا العدد بازدياد دائم إن شاء الله (مع تحديث دائم للكتب القديمة كتكملة بعض الكتب أو موافقة بعضها الآخر وتحسينها للأفضل ) ولايستغي عنها الطالب والباحث في هذه المجالات عند إعداده حلقة بحث أو رسالة الماجستير أو الدكتوراه لميزتها عن البحث التقليدي بمحرك البحث غوغل (كمثال) وهي أنها تبحث لك بقلب الكتب أما محركات البحث والمواقع تبحث في أسماء الكتب فقط !
                    </li>
                </ul>
            </v-col>
            <v-col cols="12">
                <h2 class="mb-4">المكتبة الشاملة الذهبية ببرمجتها الجديدة  حلت الكثير من المشاكل التي كان المستخدم يعاني منها سابقاً وهذه بعض الميزات التي لم تكن سابقاً :</h2>
                <ul>
                    <li class="mb-3">
                        في المكتبة الشاملة الذهبية بالإصدار الجديد يمكن للمستخدم توفير المساحة التي من المفترض أن تأخذها المكتبة على جهازه ( 1 تيرا وأكثر  ) خصوصاً لاصحاب الأجهزة القديمة والضعيفة
                    </li>
                    <li class="mb-3">
                        في المكتبة الشاملة الذهبية بالإصدار الجديد يمكن للمستخدم توفير الوقت والجهد المبذول بتحميل المكتبة خصوصاً لاصحاب الاتصال المحدود 
                    </li>
                    <li class="mb-3">
                        المكتبة الشاملة الذهبية بالإصدار الجديد سهلة وبسيطة الاستخدام بالنسبة للمستخدم اذ لا مشاكل بالتنصيب والتنزيل وفك الضغط ومشاكل توافق اللغة وغيرها 
                    </li>
                    <li class="mb-3">
                        المكتبة الشاملة الذهبية بالإصدار الجديد يمكن للمستخدم التصفح من على السيرفر من أي جهاز مهما كان نظام تشغيله (ويندوز ماك لينكس ايباد ايفون اندرويد ) وكأنها منصبة عنده ١٠٠%  ويمكنه مزامنة كتبه الخاصة بكل اجهزته بعد إنشاء حساب خاص به 
                    </li>
                    <li class="mb-3">
                        المكتبة الشاملة الذهبية بالإصدار الجديد يمكن للمستخدم توفير موارد جهازه  كالمعالج والرامات للبحث والفهرسة ومقارنة التفاسير وتخريج الأحاديث و أمور كثيرة
                    </li>
                    <li class="mb-3">
                        المكتبة الشاملة الذهبية بالإصدار الجديد تبقى مكتبة المستخدم محدثة دائماً من حيث الكتب والتخاريج وكل شيء
                    </li>
                    <li class="mb-3">
                        المكتبة الشاملة الذهبية بالإصدار الجديد بيئة تشاركية لكل الكتاب والمؤلفين اذ بإمكانهم نشر إنتاجهم مباشرة أو إنشاء مكتباتهم الخاصة وإضافة الكتب عليها 
                    </li>
                    <li class="mb-3">
                        كتب المكتبة الشاملة الذهبية بالإصدار الجديد الكثير منها يحتوي على صور وأشكال وألوان وهذا ضروري لإدارج صور المخطوطات وماشابه وهذا كان غير متاح بالإصدارات القديمة     
                    </li>
                    <li class="mb-3">
                        بالإصدار الجديد للمكتبة الشاملة الذهبية يمكنك الضغط على أي حديث فيخرج لك تخريجه أو شرحه ومايتعلق به أو على الآية فيخرج لك تفاسيرها والمقارنة بينهم وعلى اسم الراوي فترى درجته و أقوال اهل العلم فيه أو اسم أي علم فيظهر لك ترجمته وغير ذلك أمور كثيرة جداً مشابهة  
                    </li>
                    <li class="mb-3">
                        المكتبة الشاملة الذهبية بالإصدار الجديد تصميم جميل وجذاب وبرمجة حديثة تتوافق مع متطلبات العصر وتحوي الكثير من الكتب الحصرية التي لم تنشر سابقاً
                    </li>
                </ul>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
}
</script>
<style scoped>
    .v-main{
        padding: 00px 0px 58px !important
    }
</style>